module.exports = __webpack_public_path__ + "img/pstd1lwwvmk87gyxmge8geggub3y6i3525cf7c698d-ce73-4a2e-90e3-a9d4893ea924.20bd4c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pstd1lwwvmk87gyxmge8geggub3y6i3525cf7c698d-ce73-4a2e-90e3-a9d4893ea924.png
// module id = NHjn
// module chunks = 1